"use client";

import { useCoachStatus } from "@/lib/account/use-coach-status";
import { useTenant } from "@/lib/tenant/context";
import { claimTypes, useSession } from "@osn/auth";
import { getTenantData } from "@osn/helpers";
import { MainAppLayoutContext } from "@osn/react-components";
import LogoutDialog from "./LogoutDialog";
import { primaryItems, unloggedItems } from "./navigation";

export function PortalNavigationProvider({ children }: { children: React.ReactNode }) {
  const tenant = useTenant();
  const { data: session } = useSession();
  const isAuthenticated = session?.isAuthenticated ?? false;
  const { isCoach } = useCoachStatus(isAuthenticated);
  const isScorekeeper = session?.roles.includes(claimTypes.scorekeeper) || false;
  const tenantData = getTenantData(tenant.name, tenant.displayName);
  const itemsToShow = isAuthenticated ? primaryItems : unloggedItems;

  return (
    <MainAppLayoutContext.Provider
      value={{
        navigation: itemsToShow
          .filter((x) => !x.isCoachOnly || isCoach)
          .filter((x) => !(x.href === "/scorekeeping" && !isScorekeeper)),
        appName: "Participants Portal",
        tenantData,
      }}
    >
      {children}
      <LogoutDialog />
    </MainAppLayoutContext.Provider>
  );
}
